mat-dialog-content{height:100%;display:flex;flex-direction:column}.dialog-container{display:flex;gap:10px;flex:1;min-height:0}.content{flex:3 0 0}.sidebar{display:flex;flex-direction:column;justify-content:space-between;flex:1}
/*# sourceMappingURL=new-project.component-R3DBEBUA.css.map */
